module.exports = __webpack_public_path__ + "img/checked.ff77d25e.svg";